import React from 'react'
import { useParams } from 'react-router-dom'
import { Spinner } from '@/components/ui/spinner'
import RewardProgramDetailsPage from '@/routes/Marketing/RewardsHub/RewardPrograms/RewardProgramDetailsPage'
import PageNotFound from '@/routes/PageNotFound/PageNotFound'
import { useApiClient } from '@/utils/api/ApiClient'
import { TradingAccountsApiClient } from '@/utils/api/tradingAccountsApi'
import { useCallbackWithForceRefresh } from '@/utils/api/useCallbackWithForceRefresh'
import { useFetchOne } from '@/utils/api/useFetch'

export enum RewardProgramTab {
  DETAILS = 'details',
}
export const ResolveRewardPrograms: React.FC = () => {
  const { id, slug } = useParams<{ id: string; slug: RewardProgramTab }>()
  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)

  const { callback: fetchData, forceRefresh } = useCallbackWithForceRefresh(
    () => (id ? tradingAccountsApiClient.getRewardProgramDetails(id) : Promise.resolve(null)),
    [id]
  )

  const { data, isLoading } = useFetchOne(fetchData)

  if (isLoading) {
    return <Spinner />
  }

  if (!data) {
    return <PageNotFound />
  }

  if (slug === RewardProgramTab.DETAILS) {
    return (
      <React.Fragment>
        <RewardProgramDetailsPage data={data} afterSubmit={forceRefresh} />
      </React.Fragment>
    )
  }
  return <PageNotFound />
}
